<template>
    <div class="layout">
        <navigation ref="nav"></navigation>
        <div class="separator"></div>
        <div class="main-content">
            <router-view/>
        </div>
        <nover_footer></nover_footer>
    </div>
</template>

<script>
    export default {
        components: {
            navigation: () => import(
            "@/components/navigation"),
            nover_footer: () => import(
            "@/components/nover-footer")
        }
    }
</script>

<style lang="scss" scoped>
    .layout {
        display: flex;
        min-height: 100vh;
        flex-direction: column;

        .main-content {
            flex: 1;
        }
    }
</style>